import React from 'react';
import {MainBody} from './components/MainBody';
import './componentCss/app.scss';

import AdapterMoment from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MuiTheme from './materialTheme';

import {store} from './redux/store/store';
import {Provider} from 'react-redux';
import {ErrorProvider} from './contexts/ErrorContext';

import {PersistGate} from 'redux-persist/integration/react';
import {persistStore} from 'redux-persist';
import {Grid} from '@mui/material';
import {SnackbarProvider} from 'notistack';
import {GlobalSpinnerProvider} from './providers/GlobalSpinnerProvider';
import {DialogProvider} from './providers/DialogProvider';
import {ModalProvider} from './providers/ModalProvider';
import {toastConfig} from './config/toastConfig';

let persistor = persistStore(store);

export function App(props) {
    return (
        <Grid container className="app" alignItems="stretch" justifyContent="center">
            <Grid item xs={12} display="flex">
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <ErrorProvider>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <MuiTheme>
                                    <SnackbarProvider
                                        maxSnack={toastConfig.maxSnacks}
                                        anchorOrigin={toastConfig.anchorOrigin}
                                        autoHideDuration={toastConfig.duration.default}>
                                        <GlobalSpinnerProvider>
                                            <DialogProvider>
                                                <ModalProvider>
                                                    <MainBody />
                                                </ModalProvider>
                                            </DialogProvider>
                                        </GlobalSpinnerProvider>
                                    </SnackbarProvider>
                                </MuiTheme>
                            </LocalizationProvider>
                        </ErrorProvider>
                    </PersistGate>
                </Provider>
            </Grid>
        </Grid>
    );
}
